// extracted by mini-css-extract-plugin
module.exports = {"date":"style__date__UeDMU"};